import { useEffect, useState } from "react";
import { getReprtData, serviceDivisionPractice, storeReport } from "../../Services/Service";
import ModelComponent from "../components/ModelComponent";
import ReferralReportComponent from "./Referral/ReferralReportComponent";
import DivisionReportComponent from "./Division/DivisionReportComponent";
import { addToCache, clearCache, formatDate, getFromToDefaultValue } from "./utils";
import styles from "./../ProSession/components/SessionForm/SessionForm.module.css";
import { useMemo } from "react";
import LoadingButtonComponent from "./LoadingButtonComponent";

export default (() => {
    const [reportType, setReportType] = useState('referral');
    const [division, setDivision] = useState({});
    const [divisionOptions, setDivisionOptions] = useState([]);
    const [isOpenModel, setOpenModel] = useState(false);
    const [loading, setLoading] = useState(false);
    // const [referralData, setReferralData] = useState([]);
    const [referralData, setReferralData] = useState({
        areaTableData: [],
        divisonTableData: {},
        clinicData: []
    });
    const [ratingData, setRatingData] = useState({});
    const [messagesData, setMessagesData] = useState({});
    const [historyData, setHistoryData] = useState({});
    const [callData, setCallData] = useState({});
    const [financialYearRange, setFinancialYearRange] = useState({});
    const [defaultIds, setDefaultIds] = useState({
        clinicIds: [],
        divisonIds: []
    });


    const _defaultDate = getFromToDefaultValue();
    const [formData, setFormData] = useState(_defaultDate);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };
    const fetchDivsionPractice = async () => {
        let _uniqueClinics = localStorage.getItem('uniqueClinics');
        if (_uniqueClinics) {
            _uniqueClinics = await JSON.parse(_uniqueClinics);
            setDivisionOptions(_uniqueClinics);
        } else {
            await serviceDivisionPractice().then((res) => {
                if (res.data.code == 200) {
                    _uniqueClinics = res.data.data;
                    if (_uniqueClinics.length) {
                        localStorage.setItem('uniqueClinics', JSON.stringify(_uniqueClinics));
                    }
                    setDivisionOptions(_uniqueClinics);
                }
            });
        }

        const defaultIds = {
            clinicIds: _uniqueClinics.flatMap((i) => i.children).map(i => i.value),
            divisonIds: _uniqueClinics.map(i => i.value)
        }
        setDefaultIds(defaultIds);

    };

    const reportTypeOpeions = [
        {
            value: 'referral',
            label: 'Referral Report'
        },
        {
            value: 'divisional',
            label: 'Divisional Report'
        }
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        setOpenModel(true);
        setLoading(true);
        try {
            const otherData = { reportType, division: '', clinic: '' };
            otherData.division = defaultIds.divisonIds;
            otherData.clinic = defaultIds.clinicIds;
        
            // clearCache()
            if (Number(division)) {
                const _div = divisionOptions.find(i => Number(i.value) == Number(division))                            
             
                otherData.division = [division];
                otherData.clinic = (_div?.children ?? []).map(i => `${i.value}`);             
            }

            const response = await getReprtData(formData.fromDate, formData.toDate, otherData);
            const apiData = response.data.data;
            setReferralData({
                areaTableData: apiData.clinicData?.areaTableData || [],
                divisonTableData: apiData.clinicData?.divisonTableData || {},
                clinicData: apiData.clinicData || []
            });
            
            setRatingData(apiData?.ratingData ?? {});
            setMessagesData(apiData?.messagesData ?? {});
            setCallData(apiData?.callData ?? {});
            setFinancialYearRange(apiData?.getFinancialYearRange ?? {});

            // setReferralData(response?.data?.data?.clinicData || []);
            // setRatingData(response?.data?.data?.ratingData ?? {});
            // setMessagesData(response?.data?.data?.messagesData ?? {});
            // setCallData(response?.data?.data?.callData ?? {});
            // setFinancialYearRange(response?.data?.data?.getFinancialYearRange ?? {});

        } catch (e) {
            console.log(e.message);
        } finally {
            setLoading(false);
        }

        // getReprtData(startRange, endRange, division, clinic);

        // Do something with form data
    };


    const _formData = useMemo(() => ({
        _fromDate: formatDate(formData.fromDate),
        _toDate: formatDate(formData.toDate),
        division: divisionOptions.find((item) => item.value == division)
    }), [formData.fromDate, formData.toDate, division]);

    useEffect(() => {
        fetchDivsionPractice();
    }, [])

    return <form onSubmit={handleSubmit} className='border rounded p-10 mt-8'>
        <h3 className="text-2xl font-semibold leading-none tracking-tight mb-4">Generate New Report</h3>

        <div className="row g-3 align-items-center">
            <ModelComponent
                modelClass="modal-xl modal_width"
                isOpen={isOpenModel}
                onClose={() => setOpenModel(false)}
                isHeading={false}
            >
                <div style={{ overflow: 'auto' }}>
                    {
                        reportType == 'divisional' ?
                            <DivisionReportComponent
                                historyData={historyData}
                                formData={{ ..._formData, ...formData, reportType, today: _defaultDate.toDate,financialYearRange }}
                                loading={loading}
                                referralData={referralData}
                                coachingInsight={{
                                    ratingData: ratingData || {},
                                    messagesData: messagesData || {},
                                    callData: callData || {}
                                }}
                                onClose={() => setOpenModel(false)}
                            />
                            : <ReferralReportComponent
                                historyData={historyData}

                                formData={{ ..._formData, ...formData, reportType, today: _defaultDate.toDate,financialYearRange }} loading={loading} referralData={referralData}
                                onClose={() => setOpenModel(false)}
                            />
                    }
                </div>
            </ModelComponent>
            <div className="col-md-6">
                <label htmlFor="fromDate" className="form-label">From Date</label>
                <input
                    type="date"
                    className="form-control"
                    id="fromDate"
                    name="fromDate"
                    value={formData.fromDate}
                    onChange={handleChange}
                    max={new Date().toISOString().split("T")[0]}
                // required
                />
            </div>

            <div className="col-md-6">
                <label htmlFor="toDate" className="form-label">To Date</label>
                <input
                    type="date"
                    className="form-control"
                    id="toDate"
                    name="toDate"
                    value={formData.toDate}
                    onChange={handleChange}
                    max={new Date().toISOString().split("T")[0]}
                // required
                />
            </div>


            <div className="col-12">
                <label htmlFor="reportType" className="form-label">Report Type</label>
                <select
                    id="reportType"
                    className="form-select"
                    value={reportType}
                    name="reportType"
                    onChange={(e) => {
                        setReportType(e.target.value)
                        if (divisionOptions.length == 0) {
                            fetchDivsionPractice();
                        }
                    }}
                // required
                >
                    <option value="">Select Report Type</option>
                    {
                        reportTypeOpeions.map(({ label, value }) => (<option key={`report_type_${value}`} value={value}>{label}</option>))

                    }
                </select>
            </div>

            {/* Division Select */}
            {
                reportType == 'divisional' &&

                <div className={`col-12`}>
                    <label htmlFor="division" className="form-label">Division</label>
                    <select
                        id="division"
                        className="form-select"
                        value={division}
                        name="division"
                        onChange={(e) => setDivision(e.target.value)}
                    // required
                    >
                        <option value="">All </option>
                        {
                            divisionOptions.map(({ label, value }) => (<option key={`report_type_${value}`} value={value}>{label}</option>))
                        }
                    </select>
                </div>
            }

        </div>
        <div className="row mt-10">
            <div className="col">
                <LoadingButtonComponent loading={loading} disabled={loading || reportType==''} type="submit" title="Generate Report"/>
            </div>
        </div>

    </form>;
})